import React, { useEffect, useState } from "react";
import {
  EDCRSlideText,
  LoginCardWrapper,
  MarqueeText,
  ParaSlideText,
  SlideLoginCardWrapper,
  SlideLoginWrapper,
  SlideText,
  SlideWrapper,
  WelcomeSlideText,
} from "../StyledComponent";
import { bannerImgUrls } from "../data";
import Arrows from "../CustomSlideShow/Arrows";
import Dots from "../CustomSlideShow/Dots";
import CloseIcon from "@mui/icons-material/Close";

import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton } from "@mui/material";
import InputContainer from "../../../TCPForms/layout/inputContainer";
import ButtonWrapper from "../../../TCPForms/components/Button";
import { Toast } from "@egovernments/digit-ui-react-components";
import { LoginCard, PageWrapper, StyledHeading, StyledImage } from "../../DALogin2/Styled";
import { useForm } from "react-hook-form";
import { useLocation } from "react-router-dom";
import DALogin2 from "../../DALogin2/DALogin2";
import EmployeeLogin2 from "../../DALogin2/EmployeeLogin2";
import EmployeeLoginCard from "../../../../employee/Login/emploginmainpage";
import { useTranslation } from "react-i18next";

function SlideShow() {
  const getUserType = () => Digit.UserService.getType();
  const stateId = Digit.ULBService.getCurrentTenantId();
  const [showOtpField, setOtpField] = useState(false);
  const [showsecotpField, setSecondOtpField] = useState(false);
  const [showName, setName] = useState(false);
  const [showToast, setShowToast] = useState(null);
  const [loginSection, setLoginSection] = useState(false);
  const location = useLocation();
  const { handleSubmit, control } = useForm({});
  const { t } = useTranslation();
  const [flipped, setFlipped] = useState(false);

  const handleFlip = () => setFlipped(!flipped);

  const closeToast = () => {
    setShowToast(null);
  };

  const [showFeePopup, setShowFeePopup] = useState(false);

  const handlePopupClose = () => {
    setLoginSection(false);
  };

  const handleFeePopupClose = () => {
    setShowFeePopup(false);
  };

  useEffect(() => {
    if (!showToast) return;
    const timeOut = setTimeout(closeToast, 3000);
    return () => clearTimeout(timeOut);
  }, [showToast]);

  useEffect(() => {
    let timer = setInterval(() => {
      setCurrentSlide((curr) => (curr + 1 < bannerImgUrls.length ? curr + 1 : 0));
    }, 3000);

    return () => clearInterval(timer);
  }, []);

  const onSubmit = async (data) => {
    const { mobileNumber, otp, registeredName } = data;
    if (!showOtpField && !showName) {
      const requestData = {
        otp: {
          mobileNumber: mobileNumber,
          userType: "citizen",
          type: "login",
          tenantId: stateId,
        },
      };
      try {
        const res = await Digit.UserService.sendOtp(requestData, stateId);
        if (res?.isSuccessful) {
          setOtpField(true);
        }
      } catch (err) {
        setName(true);
        setShowToast({ error: true, message: `New User? Please register your detail in the portal` });
      }
    }

    if (showsecotpField) {
      const requestData = {
        name: registeredName,
        username: mobileNumber,
        otpReference: otp,
        tenantId: stateId,
        mobileNumber: mobileNumber,
      };
      try {
        const { ResponseInfo, UserRequest: info, ...tokens } = await Digit.UserService.registerUser(requestData, stateId);
        Digit.SessionStorage.set("citizen.userRequestObject", { info, ...tokens });
        Digit.UserService.setUser({ info, ...tokens });
        navigate.push("/digit-ui/citizen/profile");
      } catch (error) {
        setShowToast({ error: true, message: `Something went wrong, please try again!` });
      }
    }
    if (showName && !showOtpField && !showsecotpField) {
      const requestData = {
        otp: {
          mobileNumber: mobileNumber,
          name: registeredName,
          userType: "citizen",
          type: "register",
          tenantId: stateId,
        },
      };
      try {
        const res = await Digit.UserService.sendOtp(requestData, stateId);
        if (res?.isSuccessful) {
          setSecondOtpField(true);
        }
      } catch (err) {
        setShowToast({ error: true, message: `Something went wrong, please try again!` });
      }
    }
    if (showOtpField && !showName) {
      const requestData = {
        username: mobileNumber,
        password: otp,
        tenantId: stateId,
        userType: getUserType(),
      };
      try {
        const { ResponseInfo, UserRequest: info, ...tokens } = await Digit.UserService.authenticate(requestData);
        Digit.SessionStorage.set("citizen.userRequestObject", { info, ...tokens });
        Digit.UserService.setUser({ info, ...tokens });
        navigate.push("/digit-ui/citizen/profile");
      } catch (error) {
        setShowToast({ error: true, message: `Something went wrong, please try again!` });
      }
    }
  };

  const [currentSlide, setCurrentSlide] = useState(0);
  const [isVisible, setIsVisible] = useState(true);
  const [bgImageLoaded, setBgImageLoaded] = useState(false);
  const [bgImage, setBgImage] = useState("");

  useEffect(() => {
    const img = new Image();
    const url = bannerImgUrls[currentSlide];
    img.src = url;
    img.onload = () => {
      setBgImage(url);
      setBgImageLoaded(true);
    };
    const interval = setInterval(() => {
      // Start fade out
      setIsVisible(false);

      setTimeout(() => {
        // After fade out, change image
        setCurrentSlide((prev) => (prev + 1 < bannerImgUrls.length ? prev + 1 : 0));

        // Then fade in
        setIsVisible(true);
      }, 500); // 0.5s fade out time
    }, 4000); // Total cycle every 4s

    return () => clearInterval(interval);
  }, [currentSlide]);
  // useEffect(() => {

  // }, [currentSlide]);

  return (
    <React.Fragment>
      <SlideLoginCardWrapper>
        <SlideWrapper bgimg={bgImage} isLoaded={bgImageLoaded}>
          <SlideText>
            <WelcomeSlideText isVisible={isVisible}>{t("FASTPAS.HOME.HERO.WELCOME_TEXT")}</WelcomeSlideText>
            <EDCRSlideText>{t("FASTPAS.HOME.EDCR.TITLE")}</EDCRSlideText>
            <ParaSlideText isVisible={isVisible}>{t("FASTPAS.HOME.EDCR.DESCRIPTION")}</ParaSlideText>
          </SlideText>
          <Arrows
            prevSlide={() => setCurrentSlide((curr) => (curr - 1 < 0 ? bannerImgUrls.length - 1 : curr - 1))}
            nextSlide={() => setCurrentSlide((curr) => (curr + 1 < bannerImgUrls.length ? curr + 1 : 0))}
          />
          <Dots activeIndex={currentSlide} sliderImage={bannerImgUrls} onclick={(currentSlide) => setCurrentSlide(currentSlide)} />
        </SlideWrapper>
        <LoginCardWrapper className="flip-container">
          <div className={`flipper ${flipped ? "flipped" : ""}`}>
            <div className="login-front">
              <DALogin2 handleFlip={handleFlip} flipped={flipped} />
            </div>
            <div className="login-back">
              <EmployeeLoginCard handleFlip={handleFlip} flipped={flipped} />
            </div>
          </div>
        </LoginCardWrapper>
      </SlideLoginCardWrapper>
    </React.Fragment>
  );
}

export default SlideShow;
